import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import appLogo from '../assets/branding/logo.png';

const platforms = [
  {
    key: 'ios',
    name: 'iOS',
    blurb: 'iPhone & iPad · requires iOS 15 or later',
  },
  {
    key: 'android',
    name: 'Android',
    blurb: 'Phones & tablets · requires Android 8 or later',
  },
];

const highlights = [
  { icon: '☁️', title: 'Cloud Save', desc: 'Sign in and your empire syncs across every device.' },
  { icon: '🔔', title: 'Push Alerts', desc: 'Get notified when investors call or rivals make a move.' },
  { icon: '⚡', title: 'Play Anywhere', desc: 'Pick up your dynasty on the train, on the couch, anywhere.' },
];

export default function Download() {
  const [config, setConfig] = useState({ android: {}, ios: {} });

  useEffect(() => {
    let cancelled = false;
    fetch('/data/app_config.json')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data) setConfig(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-grid-glow">
        <div className="mx-auto max-w-5xl px-4 py-16 text-center sm:px-6 lg:px-8">
          <img src={appLogo} alt="Tech Dynasty" className="mx-auto h-20 w-20 rounded-2xl shadow-xl ring-1 ring-white/10" />
          <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-bold uppercase tracking-widest text-amber-200 backdrop-blur">
            Get the App
          </span>
          <h1 className="mt-4 text-3xl font-black text-white sm:text-4xl">
            Build your dynasty on <span className="text-gold-gradient">iOS &amp; Android</span>
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-sm text-slate-300 sm:text-base">
            Take your tech empire with you. Download Tech Dynasty and keep growing on the go.
          </p>

          <div className="mt-10 grid gap-4 sm:grid-cols-2 sm:max-w-xl sm:mx-auto">
            {platforms.map((p) => {
              const storeUrl = config?.[p.key]?.storeUrl;
              return storeUrl ? (
                <a
                  key={p.key}
                  href={storeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-gold justify-center py-4 text-base"
                >
                  Download for {p.name}
                </a>
              ) : (
                <div key={p.key} className="game-card flex flex-col items-center justify-center gap-1 px-4 py-5">
                  <p className="text-sm font-black text-white">{p.name} — Coming Soon</p>
                  <p className="text-xs text-slate-400">{p.blurb}</p>
                </div>
              );
            })}
          </div>
          <p className="mt-4 text-xs text-slate-500">
            Not live in app stores yet? Play free in your browser right now.{' '}
            <Link to="/register" className="font-bold text-amber-200 hover:underline">Create an account →</Link>
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {highlights.map((h) => (
            <div key={h.title} className="rounded-2xl border border-slate-200 bg-white p-5 text-center shadow-sm">
              <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-xl text-xl" style={{ background: 'var(--brand-bg)' }}>
                {h.icon}
              </div>
              <p className="font-black text-slate-900">{h.title}</p>
              <p className="mt-1 text-sm text-slate-500">{h.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
